export default __webpack_public_path__ + "static/media/Lab_Partner_2_PCR_Product.22025d86.svg";